<template>
  <div class="editor-module-container">
    <div class="editor-module-title">
      <div
        class="left-content"
        @click="clickRenameModule('', cvDetail.submodule_info.extras_title)"
      >
        <img v-if="moduleIcon" class="module-icon" :src="moduleIcon" alt="" />
        {{ cvDetail.submodule_info.extras_title }}
        <i class="iconfont iconedit-"></i>
        <div v-if="issueCount" class="module-issue-count">
          {{ issueCount }} 项待修复
        </div>
      </div>
      <div class="right-content">
        <i class="iconfont iconpaixu">
          <ExperienceSequence
            :list="moduleSequence"
            displayKey="title"
            @draggableChange="sequenceChange"
          />
        </i>
        <i
          class="iconfont iconshanchujianli"
          @click="handleClickRemoveModule"
        ></i>
      </div>
    </div>
    <div class="editor-module-list">
      <div class="editor-form-content">
        <div
          v-for="(item, index) in moduleSequence"
          :key="index"
          class="editor-form-item"
        >
          <template v-if="item.key === 'skill'">
            <EditorSkillAutoComplete
              v-if="extras.skill"
              :separator="separator"
              :placeholder="extrasPlaceholder.skill"
              @focus="editIdChange('skill')"
            />
            <CheckSuggestionList
              style="margin-top: 12px"
              :list="returnExtrasSuggestionList(extras[item.key])"
              :showNormalTips="true"
              hiddenBottomBtn
              @clickIgnore="clickIgnore($event, extras[item.key], 'others')"
              @buyMember="buyMember"
            />
            <template v-if="labelsVisile.skill">
              <div
                v-if="skillRecommendLabels.length"
                class="label-title"
              >
                专业技能
              </div>
              <EditorLabelsPicker
                v-if="skillRecommendLabels.length"
                class="extras-label-container"
                :value="returnLabelValue('skill')"
                :list="skillRecommendLabels"
                @clickItem="clickLabelItem($event, 'skill')"
              />
              <div
                class="label-title"
                :style="skillRecommendLabels.length ? { marginTop: '24px' } : {}"
              >
                通用技能
              </div>
              <EditorLabelsPicker
                class="extras-label-container"
                :value="returnLabelValue('skill')"
                :list="skillLabels.skill"
                valueLabel="value"
                valueKey="value"
                @clickItem="clickLabelItem($event, 'skill')"
              />
            </template>
          </template>
          <template v-else-if="extras[item.key]">
            <EditorInput
              v-model="extras[item.key].description"
              :label="item.title"
              type="textarea"
              :autosize="{ minRows: 1, maxRows: 500 }"
              resize="none"
              :placeholder="extrasPlaceholder[item.key]"
              @focus="editIdChange(item.key)"
            />
            <CheckSuggestionList
              style="margin-top: 12px"
              :list="returnExtrasSuggestionList(extras[item.key])"
              :showNormalTips="true"
              hiddenBottomBtn
              @clickIgnore="clickIgnore($event, extras[item.key], 'others')"
              @buyMember="buyMember"
            />
            <EditorLabelsPicker
              v-if="labelsVisile[item.key] && skillLabels[item.key].length"
              class="extras-label-container"
              style="margin-top: 16px"
              :value="returnLabelValue(item.key)"
              :list="skillLabels[item.key]"
              valueLabel="value"
              valueKey="value"
              @clickItem="clickLabelItem($event, item.key)"
            />
          </template>
        </div>
        <div class="complete-button-wrapper">
          <CompleteButton
            text="保存"
            @clickBtn="saveExtrasModule"
          />
        </div>
      </div>
    </div>
    <RenameModuleModal
      ref="renameModalRef"
      @confirm="confirmModuleRename($event, 'extras')"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import api from '@/api';
import ExperienceSequence from '../ExperienceSequence/ExperienceSequence.vue';
import RenameModuleModal from '../RenameModuleModal/RenameModuleModal.vue';
import EditorInput from '../EditorInput/EditorInput.vue';
import EditorAutoComplete from '../EditorAutoComplete/EditorAutoComplete.vue';
import EditorSkillAutoComplete from '../EditorSkillAutoComplete/EditorSkillAutoComplete.vue';
import EditorLabelsPicker from '../EditorLabelsPicker/EditorLabelsPicker.vue';
import CompleteButton from '../CompleteButton/CompleteButton.vue';
import extrasLabels from '@/assets/json/editor-extras.json';
import CheckSuggestionList from '../CheckSuggestionList/CheckSuggestionList.vue';
import { editorFormMixin } from '../../mixins/editor-form';
import { debounce } from '@/assets/js/util';

const EXTRAS_PLACEHOLDER = {
  skill: '技能名称（程度描述），如：PPT（可设计模版）',
  language: '语言名称（程度描述），如：英语（CET-6）',
  certificate: '证书名称（程度描述），如：CFA（二级）',
  other: '活动名称（程度描述），如：XX公众号（运营）',
  interest: '兴趣名称（程度描述），如：篮球（校队队长）',
};

export default {
  name: 'EditorExtras',
  mixins: [editorFormMixin],
  props: {
    editId: {
      type: [String, Number],
      default: '',
    },
    suggestionsModule: {
      type: Object,
      default: () => ({}),
    },
    saveLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      extrasPosition: ['language', 'certificate', 'other', 'interest', 'skill'],
      skillRecommendLabels: [],
      skillLabels: extrasLabels,
      labelsVisile: {
        skill: false,
        language: false,
        certificate: false,
      },
      extrasPlaceholder: EXTRAS_PLACEHOLDER,
      moduleSequence: [],
    };
  },
  watch: {
    editId(_, oldVal) {
      if (oldVal === 'extras-edit') {
        this.saveExtrasModule();
      }
    },
  },
  components: {
    CheckSuggestionList,
    ExperienceSequence,
    RenameModuleModal,
    EditorInput,
    EditorAutoComplete,
    EditorSkillAutoComplete,
    EditorLabelsPicker,
    CompleteButton,
  },
  computed: {
    ...mapState('editor', ['cvDetail', 'extras']),
    separator() {
      return this.cvDetail.basic_info.lang === 'cn' ? '，' : ',';
    },
  },
  methods: {
    returnExtrasSuggestionList(item) {
      if (!this.suggestionsModule || !item?.id) return [];
      return this.suggestionsModule?.[item.id]?.suggestions || [];
    },
    async updateResumeExtras() {
      try {
        const { submodule_info } = this.cvDetail;
        let payload = {};

        Object.keys(this.extras).forEach((key) => {
          if (this.extras?.[key]?.description) {
            payload[`${key}_id`] = this.extras[key].id;
          } else {
            payload[`${key}_id`] = null;
          }
        });
        let res = null;
        if (['template', 'sample'].includes(this.cvDetail.basic_info.kind)) {
          res = await this.$store.dispatch('editor/createCvDetail', {
            payload: {
              ...this.cvDetail,
              submodule_info: {
                ...submodule_info,
                ...payload,
              },
            },
            dontReload: true,
          });
        } else {
          res = await this.$store.dispatch('editor/updateCvDetail', {
            operation_type: 'update_submodule_info',
            submodule_info: {
              ...submodule_info,
              ...payload,
            },
            skipCheck: true,
          });
        }
        this.labelsVisile = {
          skill: false,
          language: false,
          certificate: false,
        };
        return res;
      } catch (error) {
        console.log(error);
      }
    },
    updateExtrasInfo(infos) {
      let extras = JSON.parse(JSON.stringify(this.extras));
      for (let key in infos) {
        if (infos[key].id) extras[key] = infos[key];
      }
      //更新cvs简历数据
      this.$store.commit('editor/setExtrasData', extras);
    },
    saveExtrasModule: debounce(async function () {
      if (this.saveLoading) return;
      this.$emit('changeSaveLoading', true);
      let { basic_info } = this.cvDetail;
      let createPayload = {
        section_lang: basic_info.lang,
        displayLoading: false,
      };
      let updatePayload = {
        section_lang: basic_info.lang,
        displayLoading: false,
      };
      // const loading = this.$message({
      //   iconClass: 'el-icon-loading',
      //   duration: 0,
      //   message: '正在修改',
      // });
      this.moduleSequence.forEach((item) => {
        if (this.extras[item.key].description) {
          if (!item.id || this.extras[item.key].kind === 'sample') {
            createPayload[item.key] = this.extras[item.key];
          } else {
            updatePayload[item.key] = this.extras[item.key];
          }
        }
      });
      //创建
      try {
        if (createPayload && Object.keys(createPayload).length > 1) {
          const res = await this.$store.dispatch('editor/createExtra', createPayload);
          if (res.code === 1000) {
            this.updateExtrasInfo(res.data.others);
          }
        }
        //更新
        if (updatePayload && Object.keys(updatePayload).length > 1) {
          const res = await this.$store.dispatch('editor/updateExtra', updatePayload);
          if (res.code === 1000) {
            this.updateExtrasInfo(res.data.others);
          }
        }
        const res = await this.updateResumeExtras();
        if (res.code === 1000) {
          this.$emit('editItem', '');
          // this.$message.success('保存成功');
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.$emit('changeSaveLoading', false);
        // loading.close();
      }
    }, 30),
    editIdChange(key) {
      this.labelsVisile[key] = true;
      this.$emit('editItem', 'extras-edit');
    },
    async handleClickRemoveModule() {
      const confirm = await this.$wondercv.showConfirm({
        title: '温馨提示',
        content: `确定要删除${this.cvDetail.submodule_info.extras_title}吗？`,
        confirmText: '确认',
        cancelText: '取消',
      });
      if (confirm) {
        this.clickRemoveModule('extras');
      }
    },
    sequenceChange() {
      this.experienceSequenceChange('extras');
    },
    returnLabelValue(item) {
      return !this.extras?.[item]?.description ? [] : this.extras?.[item]?.description.split(this.separator);
    },
    clickLabelItem(value, item) {
      this.$emit('editItem', 'extras-edit');
      const pickerValue = value.filter((v) => !!v).join(this.separator);
      this.extras[item].description = `${pickerValue}`;
    },
    calcModuleSequence() {
      const { submodule_info } = this.cvDetail;
      const { extras_position } = submodule_info || {};
      this.moduleSequence = extras_position?.length
        ? extras_position?.map((item) => ({
            id: submodule_info[`${item.slice(0, -1)}_id`],
            key: item.slice(0, -1),
            title: submodule_info[`${item.slice(0, -1)}_title`],
          }))
        : this.extrasPosition.map((item) => ({
            key: item,
            title: submodule_info[`${item}_title`],
            id: submodule_info[`${item}_id`],
          }));
    },
    async fetchSkillRecommendLabels() {
      try {
        const res = await api.cvs.getCvProfessionSkills(this.cvDetail.basic_info.token);
        if (res.code === 1000) {
          this.skillRecommendLabels = res.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    fetchSkillRemoteMethod(query) {
      if (!query) return [];
      return api.cvsEditor.skillAutoCompletions({
        keyword: query,
      });
    },
    buyMember() {
      this.$emit('buyMember');
    },
  },
  mounted() {
    this.fetchSkillRecommendLabels();
    this.calcModuleSequence();
  },
};
</script>
<style lang="scss" scoped>
@import '../../styles/editor.scss';
.editor-form-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
  .label-title {
    margin-top: 16px;
    margin-bottom: 12px;
    color: #5a616e;
    font-size: 14px;
  }
  .extras-label-container {
    gap: 10px;
    ::v-deep(.select-item) {
      padding: 0 12px;
      height: 28px;
    }
  }
}
</style>
